// src/lib/invoiceDisplay.js
import { SiXero } from "react-icons/si";

const NOTIFY_INVOICE_TEXT = {
    null: 'Not Invoiced',
    undefined: 'Not Invoiced',
    not_invoiced: 'Not Invoiced',
    invoiced: 'Invoiced',
    cod: 'COD',
    paid: 'Paid',
    deposit: 'Deposit',
    pending: 'Pending',
    voided: 'Voided',
};

const XERO_INVOICE_TEXT_ALTERED = {
    DRAFT: 'Draft',
    SUBMITTED: 'Needs Approval',
    AUTHORISED: 'Invoiced',
    PAID: 'Paid',
    VOIDED: 'Cancelled',
    DELETED: 'Deleted',
};

const XERO_INVOICE_TEXT = {
    DRAFT: 'Draft',
    SUBMITTED: 'Submitted',
    AUTHORISED: 'Authorised',
    PAID: 'Paid',
    VOIDED: 'Voided',
    DELETED: 'Deleted',
};

const SIZE_MAP = {
    sm: 12,
    md: 14,
    lg: 16,
};

export const getInvoiceSourceIcon = (quote, company, size = 'md') => {
    const source = getInvoiceStatusSource(quote, company);
    const iconSize = SIZE_MAP[size] || SIZE_MAP.md;

    if (source === 'xero') {
        return (
            <span className="inline text-blue-500" style={{ fontSize: iconSize }}>
                {/* replace with your icon */}
                <SiXero />
            </span>
        );
    }

    const gradientId = `notifyGradient-${Math.random().toString(36).slice(2)}`;

    // Notify icon (custom simple layers icon)
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 264 270"
            fill="none"
            className="inline text-zinc-500">
            <path d="M96.99 239.52H166.73C164.29 256.59 149.6 269.72 131.87 269.72C114.14 269.72 99.42 256.59 96.98 239.52H96.99ZM154.05 73.61C175.96 73.64 186.41 88.33 186.41 88.33C201.7 88.14 208.86 96.43 208.86 96.43C208.86 96.43 181.01 102.96 178.07 126.19C175.35 147.67 184.64 200.72 114.92 227.26H263.72C263.72 227.26 232.83 190.84 225.83 155.55C220.04 126.27 224.32 49.16 162.83 30.16C162.38 13.43 148.7 0 131.86 0C115.02 0 101.47 13.31 100.9 29.94C37.32 48.53 43.7 126.15 37.89 155.55C36.33 163.37 33.61 171.21 30.33 178.75C119.58 136.52 105.23 73.59 154.06 73.62L154.05 73.61ZM138.14 153.06C138.14 153.06 119.38 175.51 92.19 186.17C64.96 196.83 22.79 193.8 22.79 193.8C12.03 213.05 0 227.24 0 227.24H39.75C136.98 227.24 138.14 153.06 138.14 153.06Z" fill={`url(#${gradientId})`} />
            <defs>
                <linearGradient id={gradientId} x1="211.58" y1="80.31" x2="82.79" y2="243.87" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#33EABC" />
                    <stop offset="1" stopColor="#1F8AFE" />
                </linearGradient>
            </defs>
        </svg>

    );
};

export const getInvoiceDisplayMode = (company) => {
    return company?.settings?.invoice_display_mode || 'notify';
};

export const getNotifyInvoiceText = (quote) => {
    const status = quote?.invoice_state ?? 'not_invoiced';
    return NOTIFY_INVOICE_TEXT[status] || formatStatusText(status);
};

export const getXeroInvoiceText = (quote, company) => {
    const status = quote?.xero_invoice_status;

    if (!status) return null;

    let returnedText = XERO_INVOICE_TEXT_ALTERED[status]
    if (company?.settings?.invoice_text_mode === "xero") returnedText = XERO_INVOICE_TEXT[status]

    return returnedText || formatStatusText(status);
};

export const getInvoiceStatusText = (quote, company) => {
    const mode = getInvoiceDisplayMode(company);

    const notifyText = getNotifyInvoiceText(quote);
    const xeroText = getXeroInvoiceText(quote, company);

    if (mode === 'xero') {
        return xeroText || 'No Xero Invoice';
    }

    if (mode === 'hybrid') {
        return xeroText || notifyText;
    }

    return notifyText;
};

export const getInvoiceStatusSource = (quote, company) => {
    const mode = getInvoiceDisplayMode(company);
    const hasXero = Boolean(quote?.xero_invoice_status);

    if (mode === 'xero') return 'xero';
    if (mode === 'hybrid') return hasXero ? 'xero' : 'notify';

    return 'notify';
};

const formatStatusText = (value) => {
    if (!value) return 'Not Invoiced';

    return String(value)
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());
};